import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import MoreVert from "@material-ui/icons/MoreVert";
import { Menu, IconButton } from "@material-ui/core";

import { invokeIfFunction } from "utils/app.util";

class DropdownMenu extends PureComponent {
  state = { anchorEl: null };

  toggleMenu = () => {
    this.setState(({ open }) => ({ open: !open }));
  };

  handleClick = event => {
    event.stopPropagation();
    event.preventDefault();
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = event => {
    event.stopPropagation();
    this.setState({ anchorEl: null });
  };

  render() {
    const { children, Trigger, onClick, MenuProps } = this.props;

    const { anchorEl } = this.state;

    return (
      <React.Fragment>
        {React.cloneElement(Trigger, {
          onClick: event => {
            this.handleClick(event);
            invokeIfFunction(onClick, event);
          },
        })}
        <Menu
          PaperProps={{
            style: {
              maxHeight: "50%",
            },
          }}
          open={!!anchorEl}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          {...MenuProps}
        >
          {React.Children.toArray(children).map(child => {
            const { onClick } = child.props;

            return React.cloneElement(child, {
              onClick: event => {
                invokeIfFunction(onClick);
                this.handleClose(event);
              },
            });
          })}
        </Menu>
      </React.Fragment>
    );
  }
}

DropdownMenu.propTypes = {
  Trigger: PropTypes.element,
};

DropdownMenu.defaultProps = {
  Trigger: (
    <IconButton>
      <MoreVert fontSize="small" />
    </IconButton>
  ),
};

export default DropdownMenu;
